
import { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import moment from "moment";
//Components
import { Modal, ModalBody, ModalFooter, Button, Form } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';
import CustomSelect from 'Components/Select';
import InputDate from 'Components/InputDate';

//Actions
import { getAccounts } from 'Modules/activities/views/main/redux/saga';
import { accountsPromilesRequestRequest, clearRedux } from 'Redux/actions';

//Styles
import './index.scss';

const PromilesRequest = (props) => {

    const { messages } = useIntl();
    const dispatch = useDispatch();
    const formRef = useRef(null);

    const current_week = moment().startOf('week');
    const tempStartDate = new Date(current_week.toString());

    //Redux States
    const { openModal, loading, result, account } = useSelector(state => state.promilesRequestRedux);
    const { loadingAccounts } = useSelector(state => state.activitiesMainRedux.loadingAccounts);

    //localStates
    const [currentAccount, setCurrentAccount] = useState(null);
    const [errorAccount, setErrorAccount] = useState(null);
    const [startDate, setStartDate] = useState(tempStartDate);
    const [endDate, setEndDate] = useState(new Date());

    const getAccountsForSelect = (input, callback) => {
        if (!input) {
            callback([])
            return
        }
        getAccounts(input).then((response) => {
            if (response.result) {
                const { items } = response?.result
                callback(items)
            }
        })
    }

    const closeModal = () => {
        dispatch(clearRedux("ACCOUNTS_PROMILES_REQUEST"));
        setCurrentAccount(null);
        setErrorAccount(null);
        setStartDate(tempStartDate)
        setEndDate(new Date())
    }

    const applyChanges = () => {
        const id = account?.id || account?.compID || null;

        if (!id) return;

        const startOfDay = date => new Date(date.setHours(0, 0, 0, 0));
        const endOfDay = date => new Date(date.setHours(23, 59, 59, 999));

        const payload = {
            companyIds: [id],
            dateRange: {
                start: startOfDay(new Date(startDate)),
                end: endOfDay(new Date(endDate)),
            }
        };

        dispatch(accountsPromilesRequestRequest(payload));
    };

    useEffect(() => {
        if (openModal && account) {
            let payload = {
                id: account?.id || account?.compID || null,
                name: account?.name || account?.companyName || null,
            }
            setCurrentAccount(payload)
        }
    }, [openModal])

    useEffect(() => {
        if (result) {
            if (result.data) {
                try {
                    let data = JSON.parse(result.data)
                    if (data?.success) {
                        NotificationManager.success(messages['promiles_request_success_message'], messages['promiles_request_title'], 3000);
                        closeModal();
                    }
                } catch (error) {
                    dispatch(clearRedux("ACCOUNTS_PROMILES_REQUEST", { result: null }));
                    NotificationManager.error(messages['promiles_request_error_message'], messages['promiles_request_title'], 3000);
                }
            } else if (result.error) {
                dispatch(clearRedux("ACCOUNTS_PROMILES_REQUEST", { result: null }));
                NotificationManager.error(messages['promiles_request_error_message'], messages['promiles_request_title'], 3000);
            }
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            title={messages['promiles_request_title']}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div style={{ padding: '0 10px', height: '70vh' }}>
                    <Form
                        ref={formRef}
                        onSubmit={() => {
                            if (!currentAccount) {
                                setErrorAccount('required_field');
                                return false
                            }
                            setErrorAccount(null)
                            return true
                        }}
                        onValidSubmit={() => applyChanges()}
                    >
                        <div>
                            <CustomSelect
                                async
                                value={currentAccount}
                                onChange={(item) => {
                                    setCurrentAccount(item)
                                    setErrorAccount(null)
                                }}
                                label={messages['promiles_request_account']}
                                loadOptions={getAccountsForSelect}
                                loading={loadingAccounts}
                                getOptionLabel={e => e.name}
                                getOptionValue={e => e.id}
                                required
                                className={errorAccount && "promiles-request"}
                                disabled
                            />
                            {errorAccount && <small className="select-error text-danger">{messages[errorAccount]}</small>}
                        </div>
                        <div style={{ marginTop: 10 }}>
                            <label className="input-normal-label" style={{ marginRight: 5 }}>{messages['promiles_request_date_range']}<span className="text-danger"> *</span></label>
                            <InputDate
                                id="input-date-range"
                                type="range"
                                onChange={(value) => {
                                    const { start, end } = value;
                                    setStartDate(start);
                                    setEndDate(end);
                                }}
                                value={startDate}
                                valueEnd={endDate}
                                maxDate={new Date()}
                            />
                        </div>
                    </Form>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => formRef?.current?.submit()}
                >
                    {messages['promiles_request_send_request']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default PromilesRequest;